import { financialRecordApi } from '../api';

export const financialRecordRepo = {
    getAll: (params) => financialRecordApi.getAll(params),

    getById: (financialId) => financialRecordApi.getById(financialId),

    getByShop: (shopId) => financialRecordApi.getByShop(shopId),

    getAllByShop: (shopId, params) =>
        financialRecordApi.getAllByShop(shopId, params),

    getTotalByShop: (shopId) =>
        financialRecordApi.getTotalByShop(shopId),

    getTransactionsByShop: (shopId, params) =>
        financialRecordApi.getTransactionsByShop(shopId, params),

    create: (data) =>
        financialRecordApi.create(data),

    update: (financialId, data) =>
        financialRecordApi.update(financialId, data),

    toggleStatus: (financialId) =>
        financialRecordApi.toggleStatus(financialId),
};